import { TreeRuleConfiguration } from "./TreeRuleConfiguration";
import { TreeRuleNode } from "./Structure/TreeRuleNode";
import { IContext } from "../../Common/IContext";
import { IDesignPanelConfig } from "../../Common/IDesignPanelConfig";
import { RuleBuilderPage } from "../RuleBuilderPage";
import { DialogProps } from "../../Common/DialogProps";
import { AutoBind } from "../../Common/AutoBind";
import { StateManager } from "../../Common/StateManager";
import type { AppGlueAny } from "../../Common/AppGlueAny";

export class TreeRuleEditContext implements IContext {
    designConfig?: IDesignPanelConfig | undefined;
    runtimeConfig?: IDesignPanelConfig | undefined;
    clipboardElement: AppGlueAny;
    lastSelectionElement: AppGlueAny;

    mode: RuleBuilderPage = RuleBuilderPage.Rule;
    definition: TreeRuleConfiguration;

    title?: string;
    public onRuleSave?: () => void;
    public onRuleCancel?: () => void;

    constructor(definition: TreeRuleConfiguration) {
        this.definition = definition;
    }

    _notification: DialogProps | undefined;

    get notification() {
        return this._notification;
    }

    set notification(notification: DialogProps | undefined) {
        this._notification = notification;
        StateManager.propertyChanged(this, "notification");
    }

    private _selected: TreeRuleNode | undefined;

    get selected(): TreeRuleNode | undefined {
        return this._selected;
    }

    set selected(node: TreeRuleNode | undefined) {
        this._selected = node;

        StateManager.propertyChanged(this, "selected");
    }

    @AutoBind
    onSave() {
        if (this.title) {
            this.definition.title = this.title;
        }

        if (this.onRuleSave) {
            this.onRuleSave();
        }
    }

    @AutoBind
    onCancel() {
        this.title = this.definition.title;
        if (this.onRuleCancel) {
            this.onRuleCancel();
        }
    }

    // eslint-disable-next-line
    onCopy(id?: string) {}

    // eslint-disable-next-line
    onCut(id?: string) {}

    // eslint-disable-next-line
    onDelete(id?: string) {}

    // eslint-disable-next-line
    onPaste(id?: string) {}
}
